// WHAT: Hook für den Zugriff auf den SearchContext
// WHY:  Auslagerung des Hooks in eigene Datei, damit die Context-Datei selbst nur Komponenten exportiert

import { useContext } from "react";

import { SearchContext } from "./search-context.shared";

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
